import type { TabId } from "../types";

export const USERS_TABS: { id: TabId; label: string; icon: string }[] = [
  { id: "overview",   label: "Overview",   icon: "fa-light fa-table-columns" },
  { id: "ownership",  label: "Connections",  icon: "fa-light fa-bullhorn" },
  { id: "points",     label: "Points",     icon: "fa-light fa-award" },
  { id: "content",    label: "Content",    icon: "fa-light fa-folder-open" },
];
